import type { McpServerId } from "../types/mcp";

export const LEGACY_MCP_ACTIVE_CONNECTORS_STORAGE_KEY =
  "fintheon:mcp-active-connectors";

const ATTACHED_CONNECTORS_STORAGE_PREFIX =
  "fintheon:chat-attached-connectors:v1:";

const NARRATIVEFLOW_CONNECTOR_ALIASES = new Set([
  "narrativeflow",
  "narrativeflow-agentic",
]);

export function connectorAttachmentScopeKey(scopeId?: string | null): string {
  const scope = scopeId?.trim() || "global";
  return `${ATTACHED_CONNECTORS_STORAGE_PREFIX}${scope}`;
}

export function normalizeAttachedConnectorIds(value: unknown): McpServerId[] {
  if (!Array.isArray(value)) return [];
  const ids = [
    ...new Set(
      value
        .filter((item): item is string => typeof item === "string")
        .map((item) => item.trim())
        .filter(Boolean),
    ),
  ];
  if (
    ids.some((id) => NARRATIVEFLOW_CONNECTOR_ALIASES.has(id)) &&
    !ids.includes("narrativeflow")
  ) {
    ids.push("narrativeflow");
  }
  return ids as McpServerId[];
}

export function readAttachedConnectorIds(
  scopeId?: string | null,
): McpServerId[] {
  try {
    return normalizeAttachedConnectorIds(
      JSON.parse(
        localStorage.getItem(connectorAttachmentScopeKey(scopeId)) ?? "[]",
      ),
    );
  } catch {
    return [];
  }
}

export function writeAttachedConnectorIds(
  scopeId: string | null | undefined,
  ids: readonly McpServerId[],
): void {
  try {
    localStorage.setItem(
      connectorAttachmentScopeKey(scopeId),
      JSON.stringify(normalizeAttachedConnectorIds([...ids])),
    );
  } catch {
    /* Storage unavailable; the visual session attachment still works. */
  }
}

export function clearLegacyConnectorAttachmentState(): void {
  try {
    localStorage.removeItem(LEGACY_MCP_ACTIVE_CONNECTORS_STORAGE_KEY);
  } catch {
    /* Optional browser storage can be unavailable in standalone shells. */
  }
}
